import React, { useEffect, useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { AppComponentProps } from '../utils/types'
import {
  persist,
  RootState,
  useAppDispatch,
  useAppSelector,
} from '../utils/agent.store'
import {
  SvgDashboard,
  Loader,
  SideNav,
  // SvgWorkBenchNavIcon,
  SvgEntitiesNavIcon,
  // SvgCases,
  // SvgEnrollmentsNavIcon,
  // SvgMyTeam,
  // SvgTask,
  Modal,
  CustomButton,
  ToastContainer,
  // SvgApplicationPreferences,
  ChildType,
  SvgWarning,
  SvgCorrespondenceLogs,
  SvgPermissionAssignmentIcon,
  SvgQueues,
  MyCasesIcon,
  MyTasksIcon,
  SvgReports,
  SvgInteraction,
  useDidMountEffect,
} from '@ui-kit'
import TopBar from './TopBar'
import { NAMESPACES, PAGE_LAYOUT } from '../utils/controlTypes'
import {
  appendTenantIdToPath,
  navigateWithTenant,
  mapQueueCreationNav,
  removeToaster,
  queueListingType,
  pageableQueuesApi,
  PayloadQueueConfig,
  showLoader,
  getPermissionByTenantId,
  getAllEntities,
  IEntityType,
  setLocalEntityObject,
  getAllCategoryValues,
  updateAllCategoryDropdownData,
  setCategoryLoading,
  getAllPermissions,
  getAllEntitiesAgentAction,
  AwsPermissionType,
  setAwsPermission,
  hideLoader,
  resetLoader,
  LoginTypeEnum,
  clearSessionLastTenantId,
} from '@app-store'
import AwsConnect from '../components/AwsConnect'
import { callRoute, permissionAssignmentRoute } from '../routes/route.constant'
import { WebSocketProvider } from '../context/WebSocketContext'
import ManageQueueButton from '../components/ManageQueuesButton'
import {
  canAccessGlobalPermissionSetConfiguration,
  invalidateToken,
  permissionObject,
  programPermissionsObject,
} from '../utils/helperFunctions'
import { PERMISSION_MODULES } from '../utils/constants'

import { AWS_STRINGS, USER_PROFILE_MANAGEMENT } from '../utils/strings'
import { isEmpty } from 'lodash'
import {
  canViewCentralizedIntegrationLogs,
  isReadOnlyUser,
} from '../utils/permission'
import { getAwsPermission } from '../apis/awsConnect.api'
import { initDd } from '../../datadogAnalytics'
import { datadogRum } from '@datadog/browser-rum'
import { useStopDatadogOnTabClose } from '@ecrm-datadog'
import { performAgentDeskLogout } from '../session/agentLogout'

const PageLayout: React.FC<AppComponentProps> = () => {
  const location = useLocation()
  const isPopup = location.pathname.includes('/popup')

  const queueConfigData = useAppSelector(
    (state: RootState) => state?.queueCreation?.children
  )
  const canAccessGlobalPa = useAppSelector(
    canAccessGlobalPermissionSetConfiguration
  )
  const isSuperAdmin = useAppSelector(
    (state: RootState) => state.authUser.user?.superAdmin
  )
  const selectedClient = useAppSelector(
    (state) => state.authUser.selectedClientTenant
  )
  const withTenantPath = (path: string) =>
    appendTenantIdToPath(path, selectedClient?.id)
  const userProfile = useAppSelector(
    (state: RootState) => state?.authUser?.user?.profile
  )
  const localCommonObject = useAppSelector(
    (state: RootState) => state.localCommon
  )
  const programPermissions = useAppSelector(
    (state: RootState) => state.clientPermissions.programPermissions
  )
  const token = useAppSelector((state) => state?.session?.token ?? '')
  const awsPermission = useAppSelector((state) => state?.awsCall?.awsPermission)
  const loaderText = useAppSelector((state) => state.loader.loaderText)
  const loaderSubText = useAppSelector((state) => state.loader.loaderSubText)
  const navigate = useNavigate()
  const [entityIdWbc, setEntityIdWbc] = useState<string>('')
  const [layoutIdWbc, setLayoutIdWbc] = useState<string>('')
  const [caseIdWbc, setCaseIdWbc] = useState<string>('')
  const [entityIdWbt, setEntityIdWbt] = useState<string>('')
  const [layoutIdWbt, setLayoutIdWbt] = useState<string>('')
  const [caseIdWbt, setCaseIdWbt] = useState<string>('')
  const [queueNavConfig, setQueueNavConfig] = useState<ChildType[]>([])
  const [sideNavOpen, setSideNavOpen] = useState<boolean>(false)
  const canViewIntegrationLogs = canViewCentralizedIntegrationLogs()
  const navList = (
    entityIdWbc?: string,
    layoutIdWbc?: string,
    caseIdWbc?: string,
    entityIdWbt?: string,
    layoutIdWbt?: string,
    caseIdWbt?: string
  ) => {
    return [
      {
        label: PAGE_LAYOUT.HOME_PAGE,
        link: withTenantPath('/'),
        key: 'home',
        icon: SvgDashboard,
      },
      // TODO: Might be use later {
      //   label: PAGE_LAYOUT.MY_WORK_BENCH,
      //   link: '/intake-queue',
      //   key: 'workBench',
      //   icon: SvgWorkBenchNavIcon,
      // },
      {
        label: PAGE_LAYOUT.SEARCH,
        link: withTenantPath('/entities/0'),
        key: 'entities',
        icon: SvgEntitiesNavIcon,
      },

      {
        label: 'My Cases',
        link: withTenantPath(
          `/my-cases/${entityIdWbc}/${layoutIdWbc}/${caseIdWbc}`
        ),
        key: 'my-cases',
        icon: MyCasesIcon,
      },
      {
        label: 'My Tasks',
        link: withTenantPath(
          `/my-tasks/${entityIdWbt}/${layoutIdWbt}/${caseIdWbt}`
        ),
        key: 'my-tasks',
        icon: MyTasksIcon,
      },

      {
        label: PAGE_LAYOUT.QUEUES,
        key: 'manage-queue',
        icon: SvgQueues,
        child: queueNavConfig,
        showChildren: true,
        ...(userProfile !== USER_PROFILE_MANAGEMENT.STANDARD_USER
          ? { children: isReadOnlyUser() ? null : <ManageQueueButton /> }
          : {}),
      },
      //TODO: Might be use later {
      //   label: PAGE_LAYOUT.CASES,
      //   link: '/casessvgCases',
      //   key: 'cases',
      //   icon: SvgCases,
      // },
      // {
      //   label: PAGE_LAYOUT.MY_TEAM,
      //   link: '/myteam',
      //   key: 'team',
      //   icon: SvgMyTeam,
      // },
      // {
      //   label: PAGE_LAYOUT.MY_TASK,
      //   link: '/mytask',
      //   key: 'task',
      //   icon: SvgTask,
      // },
      // {
      //   label: PAGE_LAYOUT.ENROLLMENTS,
      //   link: '/enrollment',
      //   key: 'enroll',
      //   icon: SvgEnrollmentsNavIcon,
      // },
      // {
      //   label: PAGE_LAYOUT.INTAKE_NEW,
      //   link: '/intake-new',
      //   key: '',
      //   icon: SvgEntitiesNavIcon,
      // },
      {
        label: PAGE_LAYOUT.LOGS,
        key: 'correspondence-logs',
        icon: SvgCorrespondenceLogs,
        child: [
          {
            label: PAGE_LAYOUT.CORRESPONDENCE,
            link: withTenantPath(
              `/correspondence/correspondence-logs/outbound/${selectedClient?.id}`
            ),
            key: 'correspondence-logs',
          },
          ...(canViewIntegrationLogs
            ? [
                {
                  label: PAGE_LAYOUT.INTEGRATION,
                  link: withTenantPath(`/logs/integration-logs`),
                  key: 'integration-logs',
                },
              ]
            : []),
        ],
      },
      {
        label: PAGE_LAYOUT.CALL_INTERACTION,
        link: withTenantPath(`/${callRoute}`),
        key: 'interaction',
        icon: SvgInteraction,
      },
      // TODO: For now it is on hold
      // {
      //   label: PAGE_LAYOUT.APPLICATION_PREFERENCES,
      //   key: 'application_preferences',
      //   icon: SvgApplicationPreferences,
      //   child: [
      //     {
      //       label: APPLICATION_PREFERENCES.GENERAL_SETTINGS,
      //       link: 'application-preferences/general-settings',
      //       key: 'general-settings',
      //     },
      //     // NOTE: Agent Schedule Assignment On Hold
      //     // {
      //     //   label: APPLICATION_PREFERENCES.AGENT_SCHEDULE_SETTINGS,
      //     //   link: 'application-preferences/agent-schedule-settings',
      //     //   key: 'agent-schedule-settings',
      //     // },
      //   ],
      // },
      {
        label: PAGE_LAYOUT.OPERATIONAL_REPORTS,
        link: withTenantPath(`/operational-reports`),
        key: 'operational-reports',
        icon: SvgReports,
        visible: false, //TODO : Not needed for UAT, might need later
      },
      {
        label: PAGE_LAYOUT.PERMISSION_ASSIGNMENT,
        link: withTenantPath(`/${permissionAssignmentRoute}`),
        key: 'permission-assignment',
        icon: SvgPermissionAssignmentIcon,
        visible:
          (permissionObject.Permission_Set_Assignment_View(
            programPermissions,
            PERMISSION_MODULES.PERMISSION_ASSIGNMENT,
            'View Only'
          ) ||
            isSuperAdmin ||
            canAccessGlobalPa) &&
          !isReadOnlyUser(),
      },
    ]
  }

  const dispatch = useAppDispatch()
  const [isLogoutOpen, setIsLogoutOpen] = useState<boolean>(false)
  const toastData = useAppSelector((state) => state.toaster.toasters)
  const isLoading = useAppSelector((state) => state.loader.loading)
  const textLoadingState = useAppSelector(
    (state) => state.loader.textLoadingState
  )
  const versionDetail = useAppSelector(
    (state: RootState) => state.authUser?.versionDetails
  )
  const logOutClick = () => {
    setIsLogoutOpen((prev) => !prev)
  }

  const handleLogoutClick = async () => {
    await performAgentDeskLogout({
      dispatch,
      persist,
      token,
      loginType: LoginTypeEnum.USER_INITIATED_LOGOUT,
      invalidateToken: invalidateToken,
    })
    datadogRum.stopSession()
    clearSessionLastTenantId()
  }

  const groupifyQueues = () => {
    if (!queueConfigData) return []

    const allData = queueConfigData

    const filteredAllData = allData.filter(
      (data: { name: string }) =>
        data?.name !== 'My Cases' && data?.name !== 'My Tasks'
    )
    const enabledQueues = filteredAllData.filter(
      (item: queueListingType) => item?.enabled
    )

    const groupedMap = new Map<string, ChildType>()
    const individualItems: ChildType[] = []

    enabledQueues.forEach((queue: queueListingType) => {
      const groupId = queue?.queue_group_id?.id?.toString() ?? ''

      if (queue.queue_group_id) {
        if (!groupedMap.has(groupId)) {
          groupedMap.set(groupId, {
            label: queue.queue_group_id.name ?? '',
            key: queue.queue_group_id.name,
            child: [],
          })
        }
        groupedMap.get(groupId)!.child!.push({
          label: queue.name,
          link: withTenantPath(
            `/manage-queue/dynamic-queue/${queue.entity_id}/${queue.layout_id}/${queue.id}`
          ),
          key: `manage-queue/dynamic-queue/${queue.entity_id}/${queue.layout_id}/${queue.id}`,
        })
      } else {
        individualItems.push({
          label: queue.name,
          link: withTenantPath(
            `/manage-queue/dynamic-queue/${queue.entity_id}/${queue.layout_id}/${queue.id}`
          ),
          key: `manage-queue/dynamic-queue/${queue.entity_id}/${queue.layout_id}/${queue.id}`,
        })
      }
    })

    const combinedList: ChildType[] = [
      ...individualItems,
      ...Array.from(groupedMap.values()),
    ]

    // Sort children within each childItem
    combinedList.forEach((item) => {
      if (item.child) {
        item.child.sort((a, b) => a.label.localeCompare(b.label))
      }
    })

    // Sort childItem alphabetically by label
    combinedList.sort((a, b) => a.label.localeCompare(b.label))

    const uniqueByLabel = Array.from(
      new Map(combinedList.map((item) => [item.label, item])).values()
    )

    setQueueNavConfig(uniqueByLabel)
  }

  const getProgramIds = () => {
    const programIdsWithPermission =
      programPermissionsObject.Queues_And_Cases_View(
        programPermissions,
        PERMISSION_MODULES.QUEUE_AND_CASE_VISIBILITY,
        'View Only'
      )
    return programIdsWithPermission
  }
  const fetchMyTaskAndMyCasesQueues = async () => {
    try {
      const payload = {
        filter: {
          fields: null,
          search_criteria: [
            {
              search_key: 'NAME',
              operator: 'IN',
              search_value: ['My Cases', 'My Tasks'],
            },
          ],
        },
      }
      const queueResponse = await pageableQueuesApi(payload)
      if (queueResponse?.data?.content) {
        const queues = queueResponse?.data?.content
        const caseQueue = queues.filter(
          (data: { name: string }) => data?.name === 'My Cases'
        )
        const taskQueue = queues.filter(
          (data: { name: string }) => data?.name === 'My Tasks'
        )
        setCaseIdWbc(caseQueue?.[0]?.id?.toString())
        setEntityIdWbc(caseQueue?.[0]?.entity_id?.toString())
        setLayoutIdWbc(caseQueue?.[0]?.layout_id?.toString())
        setCaseIdWbt(taskQueue?.[0]?.id?.toString())
        setEntityIdWbt(taskQueue?.[0]?.entity_id?.toString())
        setLayoutIdWbt(taskQueue?.[0]?.layout_id?.toString())
      }
    } catch (e) {
      console.error('error : ', e)
    }
  }

  const fetchAllQueues = async () => {
    try {
      const programIds = getProgramIds()
      const programIdsFilter = {
        search_key: 'QUEUE_PROGRAMS',
        operator: 'IN',
        search_value: programIds,
      }

      const payload = {
        filter: {
          fields: null,
          search_criteria: isSuperAdmin ? [] : [programIdsFilter],
        },
      }

      const queueResponse = await pageableQueuesApi(payload)

      let mergedQueues = queueResponse?.data?.content || []

      if (!isSuperAdmin) {
        const payloadWithoutFilter = {
          filter: {
            fields: null,
            search_criteria: [],
          },
        }

        const queueResponseWithoutFilter = await pageableQueuesApi(
          payloadWithoutFilter
        )

        const filteredProgramUnassignedQueues =
          queueResponseWithoutFilter?.data?.content?.filter(
            (queue: PayloadQueueConfig) =>
              !queue?.queue_programs || queue.queue_programs?.length === 0
          ) || []

        mergedQueues = [...mergedQueues, ...filteredProgramUnassignedQueues]
      }

      dispatch(mapQueueCreationNav(mergedQueues))
    } catch (err) {
      console.error('error : ', err)
    }
  }

  const fetchAllEntities = async () => {
    try {
      if (isEmpty(localCommonObject?.entityObject)) {
        const response = await getAllEntities()
        if (response?.data) {
          const entities = response?.data
          const caseEntity = entities.find(
            (entity: IEntityType) => entity.name === 'case'
          )
          if (caseEntity) {
            dispatch(
              setLocalEntityObject({
                case: {
                  name: caseEntity?.name,
                  entityId: caseEntity?.id,
                  type: caseEntity?.type,
                },
              })
            )
          }
        }
      }
    } catch (err) {
      console.error('error : ', err)
    }
  }

  const fetchAllCategories = async () => {
    try {
      dispatch(setCategoryLoading({ loading: true }))
      const categoryValues = await getAllCategoryValues()
      if (categoryValues?.data) {
        dispatch(
          updateAllCategoryDropdownData({ allOptions: categoryValues.data })
        )
      }
      setTimeout(() => {
        dispatch(setCategoryLoading({ loading: false }))
      })
    } catch (err) {
      console.error('Error fetching all categories:', err)
    }
  }

  const fetchAwsPermission = async () => {
    dispatch(showLoader())
    try {
      const res = await getAwsPermission()
      if (res?.data) {
        const awsPermission = res.data.find(
          (list: AwsPermissionType) =>
            list.key === AWS_STRINGS.CTI_PERMISSION_KEY
        )
        dispatch(setAwsPermission(awsPermission))
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const toggleSideNav = () => {
    setSideNavOpen((prev) => !prev)
  }

  const handleRemoveToaster = (id: string) => {
    dispatch(removeToaster(id))
  }

  useStopDatadogOnTabClose()

  useDidMountEffect(() => {
    if (
      (programPermissions && Object.keys(programPermissions).length > 0) ||
      isSuperAdmin
    ) {
      fetchAllQueues()
      if (
        !isSuperAdmin &&
        programPermissions &&
        !permissionObject.Permission_Set_Assignment_View(
          programPermissions,
          PERMISSION_MODULES.PERMISSION_ASSIGNMENT,
          'View Only'
        ) &&
        location.pathname.includes(permissionAssignmentRoute)
      ) {
        navigateWithTenant(
          navigate,
          { pathname: '/', search: '' },
          { replace: true },
          selectedClient?.id
        )
      }
    }
    fetchMyTaskAndMyCasesQueues()
  }, [programPermissions])

  useEffect(() => {
    if (queueConfigData) {
      groupifyQueues()
    }
  }, [queueConfigData])

  useEffect(() => {
    if (selectedClient?.id == null) return
    dispatch(getPermissionByTenantId(selectedClient.id))
  }, [isSuperAdmin, selectedClient?.id, dispatch])

  useEffect(() => {
    dispatch(resetLoader())
    fetchAllEntities()
    fetchAllCategories()
    fetchAwsPermission()
    dispatch(getAllPermissions({}))
    dispatch(getAllEntitiesAgentAction())
    initDd()
  }, [selectedClient])

  return (
    <WebSocketProvider>
      <div id="addDataModalPortalDiv"></div>
      <div
        className={`flex flex-col h-screen ${isPopup && 'popout-window'}`}
        id="searchbar-parent"
      >
        <ToastContainer
          toastData={toastData}
          removeToaster={handleRemoveToaster}
        />
        <TopBar
          logOutClick={logOutClick}
          toggleSideNav={toggleSideNav}
          sideNavOpen={sideNavOpen}
        />
        {(isLoading || textLoadingState) && (
          <div className="absolute inset-0 flex items-center justify-center bg-opacity-75 z-[99999] backdrop-bg-opacity-75 bg-white">
            <Loader loaderText={loaderText} loaderSubText={loaderSubText} />
          </div>
        )}
        <div className="flex flex-1 h-[calc(100%-3.625rem)] w-full">
          {!isPopup && (
            <SideNav
              navList={navList(
                entityIdWbc,
                layoutIdWbc,
                caseIdWbc,
                entityIdWbt,
                layoutIdWbt,
                caseIdWbt
              )}
              versionDetail={versionDetail ?? ''}
              isOpen={sideNavOpen}
              setIsOpen={setSideNavOpen}
            />
          )}

          <main
            className={`flex-1 overflow-auto h-full transition-all ease-in-out duration-500 border-8 border-tertiary-100  ${
              sideNavOpen ? 'ml-64' : 'ml-[3.75rem]'
            }`}
          >
            {<Outlet />}
          </main>
        </div>
        {isLogoutOpen && (
          <Modal
            isOpen={isLogoutOpen}
            closeModal={() => {
              setIsLogoutOpen(false)
            }}
          >
            <div className="px-20 py-12 flex items-center mb-4 justify-center text-sm border-b h-[7.625rem]">
              <div className="h-10 w-12 flex items-center justify-center rounded-full bg-error-100">
                <SvgWarning height={'1.2rem'} width={'1.2rem'} />
              </div>
              <div className="flex items-center gap-1">
                <span className="text-sm font-medium text-accent-700">
                  {NAMESPACES.LOGOUT_MESSAGE}
                </span>
              </div>
            </div>
            <div className="mt-4 flex justify-end w-full h-10">
              <CustomButton
                onClick={logOutClick}
                widthClass="w-[8.188rem]"
                color="others"
                className="mr-3 border border-error-500"
              >
                <span className="text-xs text-accent-900">{NAMESPACES.NO}</span>
              </CustomButton>
              <CustomButton
                onClick={handleLogoutClick}
                widthClass="w-[8.188rem]"
                color="error"
                isFilled
              >
                <span className="text-xs text-accent-0">{NAMESPACES.YES}</span>
              </CustomButton>
            </div>
          </Modal>
        )}
        {/* AWS CONNECT CCP COMPONENT */}
        <div
          className={`${awsPermission?.value === 'true' ? 'block' : 'hidden'}`}
        >
          <AwsConnect />
        </div>
      </div>
    </WebSocketProvider>
  )
}

export default PageLayout
